import {
  LineChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { X_Y_AXIS_STYLE } from './constants';
import { getLineElements, getNoDataMessage } from './Elements';
import { RequestsBy } from 'utils/customTypes';
import CustomTooltip from '../../Components/CustomToolTip';
import { SLICE_STATUS } from 'utils/constants';
import ErrorScreen from '../../Components/ErrorScreen';
import RequestsBySkeletonLoading from './RequestsBySkeletonLoader';

const FormLineChart = ({
  status,
  state,
}: {
  status: string;
  state: RequestsBy;
}) => {
  return status === SLICE_STATUS.LOADING ? (
    <RequestsBySkeletonLoading />
  ) : status === SLICE_STATUS.FAILED ? (
    <ErrorScreen />
  ) : state.values.length === 0 ? (
    getNoDataMessage()
  ) : (
    <ResponsiveContainer width='90%' height='90%'>
      <LineChart data={state.values}>
        <CartesianGrid horizontal={false} vertical={false} />
        <XAxis
          tickLine={false}
          dataKey='monthShortLabel'
          style={X_Y_AXIS_STYLE}
          padding={{ left: 30, right: 30 }}
        />
        <YAxis tickLine={false} style={X_Y_AXIS_STYLE} />
        <Tooltip
          content={<CustomTooltip chartType='Line' />}
          wrapperStyle={{
            zIndex: 20,
            maxHeight: '25rem',
            overflowY: 'auto',
            pointerEvents: 'auto',
          }}
        />
        {getLineElements(state.seriesNames)}
      </LineChart>
    </ResponsiveContainer>
  );
};

export default FormLineChart;
